import React from 'react';

const Member = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.09531 9.26851V11.2607C3.09531 11.4253 3.19445 11.5818 3.35669 11.6559L7.49383 13.6318C7.63804 13.6976 7.80028 13.6976 7.94449 13.6318L12.0816 11.6559C12.2439 11.5818 12.343 11.4253 12.343 11.2607V9.26851C12.343 8.93095 11.9554 8.7169 11.631 8.87332L7.94449 10.6269C7.80028 10.6928 7.63804 10.6928 7.49383 10.6269L3.80736 8.87332C3.48288 8.7169 3.09531 8.93095 3.09531 9.26851ZM7.49383 2.71508L1.26559 5.69541C0.914073 5.86007 0.914073 6.32111 1.26559 6.48577L7.49383 9.45786C7.63804 9.52373 7.80028 9.52373 7.94449 9.45786L12.9649 7.06208C13.2894 6.90565 13.677 7.11971 13.677 7.45726V10.2812C13.677 10.5281 13.8933 10.7257 14.1637 10.7257H14.5152C14.7856 10.7257 15.002 10.5281 15.002 10.2812V6.36228C15.002 6.19762 14.9028 6.04119 14.7406 5.96709L7.94449 2.72331C7.80929 2.64922 7.63804 2.64922 7.49383 2.71508Z"
        fill="#DB0202"
      />
      <path
        d="M3.09531 9.26851V11.2607C3.09531 11.4253 3.19445 11.5818 3.35669 11.6559L7.49383 13.6318C7.63804 13.6976 7.80028 13.6976 7.94449 13.6318L12.0816 11.6559C12.2439 11.5818 12.343 11.4253 12.343 11.2607V9.26851C12.343 8.93095 11.9554 8.7169 11.631 8.87332L7.94449 10.6269C7.80028 10.6928 7.63804 10.6928 7.49383 10.6269L3.80736 8.87332C3.48288 8.7169 3.09531 8.93095 3.09531 9.26851ZM7.49383 2.71508L1.26559 5.69541C0.914073 5.86007 0.914073 6.32111 1.26559 6.48577L7.49383 9.45786C7.63804 9.52373 7.80028 9.52373 7.94449 9.45786L12.9649 7.06208C13.2894 6.90565 13.677 7.11971 13.677 7.45726V10.2812C13.677 10.5281 13.8933 10.7257 14.1637 10.7257H14.5152C14.7856 10.7257 15.002 10.5281 15.002 10.2812V6.36228C15.002 6.19762 14.9028 6.04119 14.7406 5.96709L7.94449 2.72331C7.80929 2.64922 7.63804 2.64922 7.49383 2.71508Z"
        fill="url(#paint0_linear_member)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_member"
          x1="-4.24805"
          y1="8.17392"
          x2="15.0065"
          y2="8.32863"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5353" />
          <stop offset="0.614583" stopColor="#6D38FB" />
          <stop offset="1" stopColor="#009DFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Member;
